module.exports = __webpack_public_path__ + "static/media/Partner11.f3e4a30a.webp";